
<script setup>
import {ref, computed, onMounted} from "vue";
import Notification from "@/classes/component-classes/Notification";

const closeBanner = ref(null);
const bannerType = computed(() => computedBannerType());
const icon = computed(() => computedIcon());
const emit = defineEmits(['update:modelValue'])

const props = defineProps({

  modelValue: {},

  heading: {type: String, default: 'Message'},
  content: {type: String, default: 'Please Enter A Message'},
  type: {type: String, default: 'error'},

})

onMounted(() => {

  if(props.modelValue.show) {
    clearTimeout(closeBanner.value);
    closeBanner.value = setTimeout(() => emit('update:modelValue',  new Notification()), 3500);
  }

})

function computedBannerType() {
  if(props.type === 'success') return 'background-color: #abd5b1!important; border-left: 6px solid #33852a;';
  if(props.type === 'warning') return 'background-color: #ffe4c4!important; border-left: 6px solid #f3814a;';
}

function computedIcon() {
  if(props.type === 'success') return '&#10004'
  if(props.type === 'error') return '&#10005'
  if(props.type === 'warning') return '&#9888'
}

</script>

<template>
  <div id="Vue-3-component-notification-banner" class="banner" :class="{'show' : props.modelValue.show}" :style="bannerType">
    <span class="banner__icon" v-html="icon"></span>
    <span class="banner__heading"><strong>{{heading}}</strong></span>
    <div class="banner__content">{{props.modelValue.content}}</div>
  </div>
</template>

<style scoped>

.banner {
  display:none;
  position: relative;
  background-color: #fae1e1;
  min-width: 300px;
  padding: 14px  0 10px 50px;
  height: 40px;
  top: 0;
  border-radius: 6px;
  border-left: 6px solid#cf4437;
  margin-bottom: 20px;
  line-height: 14px;
  z-index: 999999;
}

.banner__heading {
  padding-left: 5px;
}

.banner__icon {
  font-size: 30px;
  position: absolute;
  top: 24px;
  left: 10px;
}

.banner__content {
  font-size: 12px;
  padding: 5px;
}

.banner.show {
  display: block;
  animation: show_banner 1s ease forwards;
}

@keyframes show_banner {
  0% {
    transform: translateX(100%);
  }
  40% {
    transform: translateX(-10%);
  }
  80% {
    transform: translateX(0%);
  }

}


</style>
